import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=897f062c"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports